module.exports = __webpack_public_path__ + "static/img/screen.b3541ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/screen.png
// module id = 0dlO
// module chunks = 1